export const SHOUTOUT_FONTS = [
  {
    id: "walter-turncoat",
    css: "'Walter Turncoat', system-ui, sans-serif",
    weight: 400,
  },
  {
    id: "comfortaa",
    css: "'Comfortaa', system-ui, sans-serif",
    weight: 600,
  },
  {
    id: "short-stack",
    css: "'Short Stack', system-ui, sans-serif",
    weight: 400,
  },
  {
    id: "dyna-puff",
    css: "'DynaPuff', system-ui, sans-serif",
    weight: 400,
  },
  {
    id: "pangolin",
    css: "'Pangolin', system-ui, sans-serif",
    weight: 400,
  },
  {
    id: "indie-flower",
    css: "'Indie Flower', system-ui, sans-serif",
    weight: 400,
  },
];

export const getShoutoutFont = (fontId) =>
  SHOUTOUT_FONTS.find((font) => font.id === fontId) ||
  SHOUTOUT_FONTS[0];